import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "add-review-modal__error"
}

import { ref, onMounted, nextTick, watch } from 'vue';

import useContext from '@/composables/useContext';
import useTycka from '@/composables/useTycka';
import useEventListener from '@/composables/useEventListener';
import useProduct from '@/composables/useProduct';
import useReview from '@/composables/useReview';

import DrawerLayer from '@distancify-storefront/ui-drawer-layer';
import AddReview from '@/components/Reviews/AddReview.vue';
import EditReview from '@/components/Reviews/EditReview.vue';

import ReviewSubmitted from '@/components/Reviews/ReviewSubmitted.vue';
import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewModal',
  setup(__props) {

const { route } = useContext();
const { useEmitterEventListener } = useEventListener();
const { getVariant } = useProduct();
const { getReviewsStatus, setReviewStatus, reviewStatus } = useTycka();
const { setSelectedVariant, setEditReviewContext } = useReview();
const { websiteText } = useWebsiteTexts();

const isReviewModalOpen = ref(false);
const reviewSubmitted = ref(false);

const fetchReviewStatusError = ref('');

const currentReviewComponent = ref('');

const reviewComponents = {
  AddReview,
  EditReview,
};

function openModal() {
  isReviewModalOpen.value = true;
}

async function openAddReview({ variantId, reviewStatus }: any) {
  if (reviewStatus) {
    setReviewStatus(reviewStatus);
  }

  const variant = await getVariant(variantId);
  currentReviewComponent.value = 'AddReview';
  setSelectedVariant(variant);
  openModal();
}

async function openEditReview({ variantId, reviewId, review }: any) {
  const variant = await getVariant(variantId);
  currentReviewComponent.value = 'EditReview';

  setEditReviewContext({
    itemId: variantId,
    reviewId: reviewId,
    review: review
  });
  setSelectedVariant(variant);
  openModal();
}

watch(isReviewModalOpen, () => {
  if (!isReviewModalOpen.value) {
    reviewSubmitted.value = false;
  }
});

function onReviewSubmitted() {
  reviewSubmitted.value = true;
}

function openReviewSubmitted() {
  onReviewSubmitted();
  openModal();
}

function close() {
  isReviewModalOpen.value = false;
}

async function openFormIfReviewFromUrl() {
  try {
    const variantId = route.query?.itemId;
    const orderId = route.query.orderNo || route.query.transactionId;
    if (orderId && variantId) {
      await getReviewsStatus({ orderId });

      const item = (reviewStatus.value?.items || []).find(
        (r) => r === variantId
      );
      if (!item) {
        fetchReviewStatusError.value =
          websiteText('reviews__item_not_ordered').value ||
          'reviews__item_not_ordered';
        openModal();
        return;
      }
      const reviewedItem = (reviewStatus.value?.reviewedItems || []).find(
        (r) => r === item
      );
      if (reviewedItem) {
        openReviewSubmitted();
        return;
      }

      if (
        (sessionStorage.getItem('Tycka:AddReview:ItemsReviewed') || '').indexOf(
          item
        ) > -1
      ) {
        openReviewSubmitted();
        return;
      }

      await openAddReview({ variantId: variantId });
    }
  } catch (err) {
    fetchReviewStatusError.value =
      websiteText('reviews__fetch_transaction_error').value ||
      'reviews__fetch_transaction_error';
  }
}

useEmitterEventListener('Tycka:AddReview:Open', openAddReview);
useEmitterEventListener('Tycka:EditReview:Open', openEditReview);
useEmitterEventListener('Tycka:AddReview:ReviewSubmitted', onReviewSubmitted);
useEmitterEventListener('Tycka:EditReview:ReviewSubmitted', onReviewSubmitted);

onMounted(async () => {
  await openFormIfReviewFromUrl();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DrawerLayer), {
    modelValue: isReviewModalOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isReviewModalOpen).value = $event)),
    showCloseIcon: true,
    containerClass: "add-review-modal__container",
    modalClass: "add-review-modal--center"
  }, {
    default: _withCtx(() => [
      (!fetchReviewStatusError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!reviewSubmitted.value)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(reviewComponents[currentReviewComponent.value]), { key: 0 }))
              : (_openBlock(), _createBlock(ReviewSubmitted, { key: 1 }))
          ]))
        : _createCommentVNode("", true),
      (fetchReviewStatusError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(fetchReviewStatusError.value), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})